import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _SET_NAVIGATION$SET_N;
import { SET_NAVIGATION, SET_NAVIGATION_SERVICES } from './types';
export default (_SET_NAVIGATION$SET_N = {}, _defineProperty(_SET_NAVIGATION$SET_N, SET_NAVIGATION, function (state, payload) {
  state.navigation = payload;
}), _defineProperty(_SET_NAVIGATION$SET_N, SET_NAVIGATION_SERVICES, function (state, payload) {
  state.navigationServices = payload;
}), _SET_NAVIGATION$SET_N);